import { getUrlParamValue } from '../../../utilities/browser';

const getCurrentPage = (key: string = 'page') => {
  const findCurrentPage = getUrlParamValue(key);
  return (findCurrentPage !== null) ? findCurrentPage : 1;
};

export default getCurrentPage;
